function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PieChart from '@rd-web-markets/shared/dist/dashboards/components/PieChart';
import DashCard from '@rd-web-markets/shared/dist/dashboards/components/DashCard';
const ClaimGroupProjectStatePieChart = _ref => {
  let {
    dashboardData,
    labels = ['Completed', 'To Be Assessed', 'In Progress'],
    ...props
  } = _ref;
  // we show dummy data in some dashboards
  const series = dashboardData?.projectStatuses?.length ? dashboardData.projectStatuses : [3, 4, 5];
  return /*#__PURE__*/React.createElement(DashCard, _extends({}, props, {
    title: "Project Status"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      height: '25px'
    }
  }), /*#__PURE__*/React.createElement(PieChart, {
    className: "pos-rel-top-10",
    labels: labels,
    series: series,
    label: 'Total Projects'
  }));
};
export default ClaimGroupProjectStatePieChart;